import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import './ModalСonfirmation.scss'
import { TextPage } from '../../../components/TextPage/TextPage';
import { ModalComponent } from "../../../components/Modal/ModalComponent/ModalComponent";

const ModalСonfirmation = ({
    setIsModal,
    onUploadFile,
    selectedFile,
    setSelectedFile
}) => {

    const onClose = () => {
        setIsModal(false)
        setSelectedFile(null)
    }

    return (
        <ModalComponent
            onClose={e => setIsModal(false)}
            title="Выберите действие:"
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-confirmation-v2'>
                    <TextPage
                        text={<><span style={{ color: '#1890FF', fontWeight: 600 }}>Заменить: </span> удалить и заменить все значения на данные из файла</>}
                    />
                    <TextPage
                        text={<><span style={{ color: '#22C55E', fontWeight: 600 }}>Добавить: </span> обновить существующие и добавить новые значения из файла</>}
                    />
                    <div className='modal-confirmation-v2__group-btn'>
                        <ButtonBasic
                            blue
                            text='Заменить'
                            width='100%'
                            onClick={(e) => {
                                onUploadFile(selectedFile, true)
                                onClose(false)
                            }}
                        />
                        <ButtonBasic
                            green
                            text='Добавить'
                            width='100%'
                            onClick={(e) => {
                                onUploadFile(selectedFile, false)
                                onClose(false)
                            }}
                        />
                        <ButtonBasic
                            red
                            text='Отмена'
                            width='100%'
                            onClick={(e) => {
                                onClose(false)
                            }}
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalСonfirmation }